// frontend/src/pages/public/HomeGate.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import HomePage from "./HomePage";

/**
 * HomeGate — controls what "/" shows.
 *
 * Authenticated visitors are sent to their dashboard; everyone else gets the
 * public marketing home. While the initial session check is in flight we render
 * the marketing home (it's the safe public default and avoids a blank flash).
 */
export default function HomeGate() {
  const { token, loading } = useAuth();
  if (!loading && token) {
    return <Navigate to="/dashboard" replace />;
  }
  return <HomePage />;
}
